import { computed } from 'vue'
import { validLength, validEmail } from '../api/checker'

export default function ( account, password ){

  //�A�J�E���gID
  const accountIdValidator = () =>{
	return validLength(1, 45, account.value.userid)
  }
  
  const accountIdEmailValidator = () =>{
	return validEmail( account.value.userid)
  }

  //���[�U
  const nameValidator = () =>{
	return validLength(1, 45, account.value.name)
  }

  //��Ж�
  const companyNameValidator = () =>{
	return validLength(1, 100, account.value.companyname)
  }

  //�����CD
  const suppliersCdValidator = () =>{
	return validLength(0, 45, account.value.supplierscd)
  }

  //������
  const departmentValidator = () =>{
	return validLength(0, 100, account.value.department)
  }

  //�E�H�[�^�[�}�[�N
  const waterMarkValidator = () =>{
	return validLength(1, 30, account.value.watermark)
  }

  //���l�`�F�b�N
  const remarkValidator = () =>{
	return validLength(0, 255, account.value.remark)
  }

  //�p�X���[�h�`�F�b�N
  const passwordValidator = () =>{
    if( account.value.id == null || account.value.id.length == 0 ){
      return validLength(1, 10, password.value)
    }else{
      return validLength(0, 10, password.value)
    }
  }


  
  //�S�Ẵ`�F�b�N
  const allValidator = () =>{
    var res = ( computed( remarkValidator ).value )
    
    if( res ){
      res = ( computed( accountIdValidator ).value )
    }
    
    if( res ){
      res = ( computed( nameValidator ).value )
    }

    if( res ){
      res = ( computed( companyNameValidator ).value )
    }
    if( res ){
      res = ( computed( departmentValidator ).value )
    }
    if( res ){
      res = ( computed( waterMarkValidator ).value )
    }

    if( res ){
      res = ( computed( passwordValidator ).value )
    }
    
    if( res ){
      res = ( computed( suppliersCdValidator ).value )
    }
    
    if( res ){
      res = ( computed( accountIdEmailValidator ).value )
    }

    
    if( res ){
      return false
    }else{
      return true
    }
  }
  
  

  //computed�ɐݒ�
  //�e���ڂ̓��͂��ω������ۂɏ������N��
  //�S�`�F�b�N�͓o�^�{�^�������ۂɎg�p����
  const resRemarkVal = computed( remarkValidator )
  const resAccountIdVal = computed( accountIdValidator )
  const resNameVal = computed( nameValidator )
  const resCompanyNameVal = computed( companyNameValidator )
  const resDepartmentVal = computed( departmentValidator )
  const resWaterMarkVal = computed( waterMarkValidator )
  const resPasswordVal = computed( passwordValidator )  
  const resSuppliersCdVal = computed( suppliersCdValidator )
  const resAccountIdEmailVal = computed( accountIdEmailValidator )
  
  const resAllVal = computed( allValidator )

  //���Y���W���[�����񋟂���ϐ��A���\�b�h��錾
  return{
	resRemarkVal,
	resAccountIdVal,
	resNameVal,
	resCompanyNameVal,
	resDepartmentVal,
	resWaterMarkVal,
	resPasswordVal,
	resSuppliersCdVal,
	resAccountIdEmailVal,
	resAllVal
  }
}